(() => {
  'use strict';
  if (window.postbusNavigationInitialized) return;
  window.postbusNavigationInitialized = true;

  const headers = new Set();
  const desktop = window.matchMedia('(min-width: 1101px)');
  const compact = window.matchMedia('(max-width: 380px)');
  let frame = 0;

  const disclosures = header => Array.from(header.querySelectorAll('[data-pb29-disclosure]'));
  const position = header => {
    const bottom = Math.max(0, Math.ceil(header.getBoundingClientRect().bottom));
    const viewport = window.visualViewport;
    header.style.setProperty('--pb29-header-bottom', `${bottom}px`);
    header.style.setProperty('--pb29-viewport-bottom', `${Math.floor(viewport ? viewport.offsetTop + viewport.height : window.innerHeight)}px`);
  };
  const sync = header => {
    const items = disclosures(header);
    const open = items.some(item => item.open);
    const shade = header.querySelector('[data-pb29-dismiss]');
    if (shade) shade.hidden = !open;
    items.forEach(item => {
      const summary = item.querySelector(':scope > summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', String(item.open));
      const label = item.open ? summary.dataset.pb29CloseLabel : summary.dataset.pb29OpenLabel;
      if (label) summary.setAttribute('aria-label', label);
    });
    if (open) position(header);
  };
  const close = (item, restoreFocus = false) => {
    if (!item?.open) return;
    item.open = false;
    sync(item.closest('[data-pb29-header]'));
    if (restoreFocus) item.querySelector(':scope > summary')?.focus({ preventScroll: true });
  };
  const closeAll = except => {
    headers.forEach(header => {
      if (!header.isConnected) { headers.delete(header); return; }
      disclosures(header).forEach(item => { if (item !== except) close(item); });
    });
  };
  const updatePosition = () => {
    if (frame) return;
    if (!Array.from(headers).some(header => header.querySelector('[data-pb29-disclosure][open]'))) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      headers.forEach(header => {
        if (!header.isConnected) headers.delete(header);
        else if (header.querySelector('[data-pb29-disclosure][open]')) position(header);
      });
    });
  };
  const init = scope => {
    const candidates = scope.matches?.('[data-pb29-header]') ? [scope] : scope.querySelectorAll('[data-pb29-header]');
    candidates.forEach(header => {
      if (headers.has(header)) return;
      headers.add(header);
      sync(header);
      header.addEventListener('toggle', event => {
        const item = event.target;
        if (!item.matches?.('[data-pb29-disclosure]')) return;
        if (item.open) {
          closeAll(item);
          if (item.dataset.pb29Disclosure === 'search') {
            requestAnimationFrame(() => { if (item.open) item.querySelector('input[type="search"]')?.focus({ preventScroll: true }); });
          }
        }
        sync(header);
      }, true);
      header.addEventListener('click', event => {
        if (event.target.closest('[data-pb29-close]')) {
          close(event.target.closest('[data-pb29-disclosure]'), true);
          return;
        }
        if (event.target.closest('[data-pb29-dismiss]')) {
          close(header.querySelector('[data-pb29-disclosure][open]'), true);
          return;
        }
        const favorites = event.target.closest('[data-pb26-favorites]');
        if (favorites) {
          close(favorites.closest('[data-pb29-disclosure]'), true);
          closeAll();
          return;
        }
        if (event.target.closest('a')) closeAll();
      });
    });
  };

  document.addEventListener('click', event => {
    if (!event.target.closest('[data-pb29-header]')) closeAll();
  });
  document.addEventListener('focusin', event => {
    closeAll(event.target.closest('[data-pb29-disclosure]'));
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const item = document.querySelector('[data-pb29-header] [data-pb29-disclosure][open]');
    if (!item) return;
    event.preventDefault();
    close(item, true);
  });
  const handleBreakpoint = () => {
    headers.forEach(header => {
      disclosures(header).forEach(item => {
        if ((desktop.matches && item.dataset.pb29Disclosure === 'menu') || (compact.matches && item.dataset.pb29Disclosure === 'search')) {
          const hadFocus = item.contains(document.activeElement);
          close(item);
          if (hadFocus) header.querySelector('.pb26-logo')?.focus({ preventScroll: true });
        }
      });
    });
    updatePosition();
  };
  desktop.addEventListener('change', handleBreakpoint);
  compact.addEventListener('change', handleBreakpoint);
  window.addEventListener('resize', updatePosition, { passive: true });
  window.addEventListener('scroll', updatePosition, { passive: true });
  window.visualViewport?.addEventListener('resize', updatePosition, { passive: true });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    headers.forEach(header => { if (event.target.contains(header)) headers.delete(header); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
